// Service titles match the on-page service buttons (hero pills + section CTAs)
// so customers see the exact same options in the booking dropdown.
export const mockServices = [
  {
    id: 1,
    title: "Pain Relief Treatments",
    description: "Targeted cryotherapy for pain, inflammation, and recovery.",
    price: "$40-$80",
    duration: "15-20 minutes"
  },
  {
    id: 2,
    title: "Fat Reduction Treatments",
    description: "Cryolipolysis treatments for body contouring and fat loss.",
    price: "$50-$70",
    duration: "20-30 minutes"
  },
  {
    id: 3,
    title: "Gym Partnerships",
    description: "On-site cryotherapy for gym members and fitness facilities.",
    price: "Contact for pricing",
    duration: "Varies"
  },
  {
    id: 4,
    title: "Sports Teams",
    description: "Team recovery sessions for games, practices, and tournaments.",
    price: "$400-$600 per event",
    duration: "Half day / Full day"
  },
  {
    id: 5,
    title: "Races & Track Events",
    description: "On-site recovery for 5K, 10K, marathons, and track meets.",
    price: "$400-$600 per event",
    duration: "Event duration"
  },
  {
    id: 6,
    title: "Baseball",
    description: "Pitcher arm care, catcher recovery, and full team treatments.",
    price: "$400-$600 per event",
    duration: "Game / Event"
  },
  {
    id: 7,
    title: "Corporate Wellness",
    description: "Employee wellness events and office recovery days.",
    price: "$500-$700",
    duration: "Half day"
  },
  {
    id: 8,
    title: "Chiropractors/Physical Therapists",
    description: "Partner with us to offer cryotherapy to your patients.",
    price: "Contact for pricing",
    duration: "Varies"
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "Marcus Johnson",
    role: "Professional Athlete",
    content: "Ice Man Cryo has been a game-changer for my recovery routine. The mobile service makes it incredibly convenient, and I feel the difference after every session!",
    rating: 5,
    avatar: "MJ"
  },
  {
    id: 2,
    name: "Sarah Williams",
    role: "Fitness Enthusiast",
    content: "I've tried the weight loss and aesthetic treatments - absolutely love the results! My skin looks amazing and I feel more energized. Highly recommend!",
    rating: 5,
    avatar: "SW"
  },
  {
    id: 3,
    name: "David Chen",
    role: "Business Executive",
    content: "The convenience of having cryo therapy come to my location in Midtown is unbeatable. Great for stress relief and energy boost during busy work weeks.",
    rating: 5,
    avatar: "DC"
  },
  {
    id: 4,
    name: "Jennifer Martinez",
    role: "Wellness Coach",
    content: "Ice Man Cryo offers professional service with impressive results. The localized treatments have helped several of my clients with pain management and recovery.",
    rating: 5,
    avatar: "JM"
  }
];

export const mockBenefits = [
  {
    icon: "Zap",
    title: "Fast Targeted Treatments",
    description: "Precision cold therapy exactly where your body needs it most."
  },
  {
    icon: "Activity",
    title: "Reduce Inflammation",
    description: "Helps reduce inflammation and pain for faster recovery."
  },
  {
    icon: "Sparkles",
    title: "Support Recovery",
    description: "Supports athletic recovery and reduces muscle soreness."
  },
  {
    icon: "Flame",
    title: "Fat Reduction",
    description: "Can assist with fat reduction and skin tightening."
  },
  {
    icon: "Shield",
    title: "Mobile Service",
    description: "Mobile and on-site services available throughout Atlanta."
  },
  {
    icon: "TrendingUp",
    title: "No Chamber Needed",
    description: "Targeted localized treatment without a full-body chamber."
  }
];

export const mockBookingTimes = [
  "9:00 AM",
  "10:00 AM",
  "11:00 AM",
  "12:00 PM",
  "1:00 PM",
  "2:00 PM",
  "3:00 PM",
  "4:00 PM",
  "5:00 PM",
  "6:00 PM"
];

export const mockFAQs = [
  {
    question: "What is the America Cryo Subzero system?",
    answer: "The America Cryo Subzero is a localized cryotherapy device that delivers short bursts of pressurized CO2 at about -110°F. It's designed for targeted pain relief, inflammation reduction, body sculpting, and athletic recovery."
  },
  {
    question: "Is cryotherapy safe?",
    answer: "Yes! Localized cryotherapy is a safe, non-invasive treatment. Our certified professionals ensure proper protocols are followed for every session. We'll discuss any health concerns during your consultation."
  },
  {
    question: "How is this different from a cryo chamber?",
    answer: "Unlike whole-body cryo chambers, the Subzero system provides targeted localized treatment to specific areas. This means faster sessions, no chamber entry required, and precision treatment where you need it most."
  },
  {
    question: "Do you service all of Atlanta?",
    answer: "We're based in Midtown Atlanta and provide mobile services throughout the greater Atlanta area. We come to gyms, teams, events, and individual clients. Contact us to confirm we service your location!"
  },
  {
    question: "What should I wear during treatment?",
    answer: "Wear comfortable, loose-fitting clothing. For localized treatments, you'll only need to expose the treatment area. We'll provide specific instructions when you book."
  }
];
